export const ROOT_PATH = '/';
export const SHORTCUT_MAIN_PATH = '/main';
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';

// CMIS
export const CMIS_PATH = '/medical-alert-drug-allergy';

// ORIGIN
export const ROUTER_BACK_PATH = '/router-back';

// INTERCEPTION
export const EXTERNAL_LINK_INTERCEPTION = 'action=externallink';
export const ACTION_BACK_PATH = `?action=back`;

export const FORCE_BACK_PATH = `forceback`;

// Query Params in Appointment Module
export const NN_TRIAGE_QUESTIONNAIRE = 'triagequestionnaire';

// PAYMENTS
export const PAYMENTS_PATH = '/payments';
export const PAYMENTS_OUTSTANDING_PATH = `${PAYMENTS_PATH}/outstanding`;
export const PAYMENTS_OUTSTANDING_CLUSTER_PATH = `${PAYMENTS_PATH}/outstanding/:clusterCode`;
export const PAYMENTS_ADD_BILL_PATH = `${PAYMENTS_PATH}/add-bill`;
export const PAYMENTS_SUMMARY_PATH = `${PAYMENTS_PATH}/summary`;
export const PAYMENTS_CHECK_STATUS_PATH = `${PAYMENTS_PATH}/status`;
export const PAYMENTS_RECEIPT_PATH = `${PAYMENTS_PATH}/receipt`;
export const PAYMENTS_DD_RECEIPT_PATH = `${PAYMENTS_PATH}/direct-debit-receipt`;
export const PAYMENTS_PUBLIC_PATH = '/public/payments';
export const PAYMENTS_PUBLIC_CHECK_STATUS_PATH = `${PAYMENTS_PUBLIC_PATH}/status`;
export const PAYMENTS_PUBLIC_RECEIPT_PATH = `${PAYMENTS_PUBLIC_PATH}/receipt`;
export const PAYMENTS_PUBLIC_ADD_BILL_PATH = `${PAYMENTS_PUBLIC_PATH}/add-bill`;
export const PAYMENTS_SUMMARY_PUBLIC_PATH = `${PAYMENTS_PUBLIC_PATH}/summary`;

// PAYMENTS V2
export const PAYMENT_SERVICE_PATH = '/payment-service';
export const PAYMENT_SERVICE_SUMMARY_PATH = `${PAYMENT_SERVICE_PATH}/summary`;
export const PAYMENT_SERVICE_PUBLIC_PATH = '/public/payment-service';
export const PAYMENT_SERVICE_SUMMARY_PUBLIC_PATH = `${PAYMENT_SERVICE_PUBLIC_PATH}/summary`;
export const PAYMENT_SERVICE_PAYMENT_OPTIONS_PATH = `${PAYMENT_SERVICE_PATH}/payment-options`;
export const PAYMENT_SERVICE_PUBLIC_PAYMENT_OPTIONS_PATH = `${PAYMENT_SERVICE_PUBLIC_PATH}/payment-options`;
export const PAYMENT_SERVICE_CALLBACK_PATH = `${PAYMENT_SERVICE_PATH}/callback`;
export const PAYMENT_SERVICE_TOKENIZATION_PATH = `${PAYMENT_SERVICE_PATH}/link-card`;
export const PAYMENT_SERVICE_TOKENIZATION_CALLBACK_PATH = `${PAYMENT_SERVICE_PATH}/tokenize-callback`;
export const PAYMENT_SERVICE_TOKENIZATION_STATUS_PATH = `${PAYMENT_SERVICE_TOKENIZATION_PATH}/status`;
export const PAYMENT_SERVICE_TOKENIZATION_MANAGE_PATH = `${PAYMENT_SERVICE_TOKENIZATION_PATH}/manage`;

// BILLS
export const BILLS_PATH = '/bills';
export const BILLS_ADD_BILL_PATH = `${BILLS_PATH}/add-bill`;
export const BILLS_PUBLIC_PATH = '/public/bills';
export const BILLS_PUBLIC_ADD_BILL_PATH = `${BILLS_PUBLIC_PATH}/add-bill`;
export const BILLS_CHECK_STATUS_PATH = `${BILLS_PATH}/status`;
export const BILLS_PUBLIC_CHECK_STATUS_PATH = `${BILLS_PUBLIC_PATH}/status`;

// AUTOPAY
export const AUTOPAY_PATH = '/auto-pay';
export const AUTOPAY_ADD_SELECT_INSTITUTION_PATH = `${AUTOPAY_PATH}/add/select-institution`;
export const AUTOPAY_TERMS_AND_CONDITION_PATH = `${AUTOPAY_PATH}/add/terms-and-conditions`;
export const AUTOPAY_TERMS_AND_CONDITION_DETAILS_PATH = `${AUTOPAY_PATH}/add/terms-and-conditions/details`;
export const AUTOPAY_ADD_SELECT_PATIENT_PATH = `${AUTOPAY_PATH}/add/select-patient`;
export const AUTOPAY_PATIENT_DETAILS_PATH = `${AUTOPAY_PATH}/add/patient-details`;
export const AUTOPAY_ADD_PARTICULARS_PATH = `${AUTOPAY_PATH}/add/particulars`;
export const AUTOPAY_VERIFY_PAYOR_PATH = `${AUTOPAY_PATH}/add/verify-payor`;
export const AUTOPAY_VERIFY_PAYOR_SUMMARY_PATH = `${AUTOPAY_PATH}/add/verify-payor-summary`;
export const AUTOPAY_ADD_CARD_DETAILS_PATH = `${AUTOPAY_PATH}/add/card-details`;
export const AUTOPAY_PATIENT_SETUP_STATUS_PATH = `${AUTOPAY_PATH}/patient-setup-status`;
export const AUTOPAY_VIEW_SELECT_INSTITUTION_PATH = `${AUTOPAY_PATH}/view/select-institution`;
export const AUTOPAY_VIEW_SELECT_PATIENT_PATH = `${AUTOPAY_PATH}/view/select-patient`;
export const AUTOPAY_VIEW_CARD_LIST_PATH = `${AUTOPAY_PATH}/view/card-list`;
export const AUTOPAY_MANAGE_CARD_PATH = `${AUTOPAY_PATH}/view/manage-card`;
export const AUTOPAY_CARD_UPDATE_STATUS_PATH = `${AUTOPAY_PATH}/autopay-card-update-status`;

export const LAB_TEST_REPORTS_PATH = `/lab-test-reports`;

// Refunds
export const REFUNDS_PATH = '/refunds';
export const REFUNDS_SELECT_INSTITUTION_PATH = `${REFUNDS_PATH}/select-institution`;
export const REFUNDS_SELECT_PATIENT_PATH = `${REFUNDS_PATH}/select-patient`;
export const REFUNDS_ADD_REFUND_PATH = `${REFUNDS_PATH}/add-refund`;
export const REFUNDS_TERMS_AND_CONDITIONS_PATH = `${REFUNDS_PATH}/terms-and-conditions`;
export const REFUNDS_SUMMARY_PATH = `${REFUNDS_PATH}/refund-summary`;
export const REFUNDS_STATUS_PATH = `${REFUNDS_PATH}/refund-status`;

// LAB RESULTS
export const LAB_TEST_RESULTS_PATH = `${LAB_TEST_REPORTS_PATH}/lab`;
export const LAB_TEST_RESULTS_DETAILS_PATH = `${LAB_TEST_RESULTS_PATH}/details`;

// PRESCRIPTION
export const PRESCRIPTION_PATH = '/prescription-records';
export const PRESCRIPTION_DETAILS_PATH = `${PRESCRIPTION_PATH}/details`;

// IMMUNISATION RECORDS
export const IMMUNISATION_RECORDS_PATH = '/immunisation';
export const MORE_ABOUT_IMMUNISATION_PATH = `${IMMUNISATION_RECORDS_PATH}/more-info`;
export const COMPLETED_IMMUNISATIONS_PATH = `${IMMUNISATION_RECORDS_PATH}/completed`;
export const NATIONALLY_RECOMMENDED_PATH = `${IMMUNISATION_RECORDS_PATH}/recommendation`;
export const UPCOMING_IMMUNISATION_PATH = `${IMMUNISATION_RECORDS_PATH}/recommendation/upcoming`;
export const MISSED_IMMUNISATION_PATH = `${IMMUNISATION_RECORDS_PATH}/recommendation/missed`;
export const HEALTHIERSG_IMMUNISATIONS_RECORDS_PATH = `${IMMUNISATION_RECORDS_PATH}/records`;

// NEHR ACCESS HISTORY
export const NEHR_ACCESS_HISTORY_PATH = '/nehr-access-history';
export const PUBLIC_HEALTHCARE_CLUSTERS_PATH = `${NEHR_ACCESS_HISTORY_PATH}/public-healthcare`;

// NEHR ACCESS RESTRICTION
export const NEHR_ACCESS_RESTRICTION_PATH = '/nehr-access-restriction';
export const NEHR_ACCESS_RESTRICTION_VIDEO_PATH = '/nehr-access-restriction/video';
export const NEHR_ACCESS_RESTRICTION_DECLARATION_PATH = '/nehr-access-restriction/declaration';
export const NEHR_ACCESS_RESTRICTION_INFO_PATH = '/nehr-access-restriction/info';
export const NEHR_ACCESS_RESTRICTION_MODIFY_PATH = '/nehr-access-restriction/modify';
export const NEHR_ACCESS_RESTRICTION_SEARCH_PATH = '/nehr-access-restriction/search';
export const NEHR_ACCESS_RESTRICTION_SUBMITTED_PATH = '/nehr-access-restriction/submitted';

// ACCOMPANYING VISITOR
export const ACCOMPANYING_VISITOR_PATH = '/accompanying-visitor';
export const ACCOMPANYING_VISITOR_LISTING_PATH = `${ACCOMPANYING_VISITOR_PATH}/listing`;

// SCREEN FOR LIFE RENAME TO Healthier SG Screening
export const SFL_LETTER_PATH = '/healthiersg-screening';

// HEALTH_SCREENING
export const HEALTH_SCREENING_PATH = '/health-screening';
export const HEALTH_SCREENING_SUMMARY_PATH = '/health-screening/summary';
export const HEALTH_SCREENING_HISTORY_PATH = '/health-screening/history';
export const HEALTH_SCREENING_SCREENING_TYPE_SUMMARY_PATH = `${HEALTH_SCREENING_PATH}/:screeningType`;
export const HEALTH_SCREENING_DETAILS_PATH = `${HEALTH_SCREENING_PATH}/details/:screeningType`;
export const HEALTH_SCREENING_UNDERSTAND_MY_READINGS_PATH = `${HEALTH_SCREENING_PATH}/understand-readings/:screeningType`;
export const HEALTH_SCREENING_RESULTS_PATH = `${HEALTH_SCREENING_PATH}/results/:screeningType`;
export const HEALTH_SCREENING_RESULTS_INDICATOR_PATH = `${HEALTH_SCREENING_PATH}/results/indicator/:recordType`;

// DISCHARGE SUMMARY
export const DISCHARGE_SUMMARY_PATH = '/discharge-summary';
export const DISCHARGE_SUMMARY_DETAIL_PATH = `${DISCHARGE_SUMMARY_PATH}/:id`;

// RADIOLOGY
export const RADIOLOGY_PATH = '/radiology';
export const RADIOLOGY_DETAILS_PATH = `${RADIOLOGY_PATH}/details`;

// CHAS
export const CHAS_PATH = '/chas';
export const CHAS_SUBSIDY_BALANCE_PATH = `${CHAS_PATH}/subsidy-balance/:chasType`;
export const CHAS_VISIT_BALANCE_PATH = `${CHAS_PATH}/visit-balance`;
export const CHAS_DENTAL_SUBSIDY_BALANCE_PATH = `${CHAS_PATH}/dental-subsidy-balance/:tab`;
export const CHAS_TRANSACTION_HISTORY_PATH = `${CHAS_PATH}/transaction-history`;

// CAREGIVERS
export const MY_CARE_GIVERS_PATH = '/caregivers';
export const UPDATE_CARE_GIVERS_DETAILS_PATH = `${MY_CARE_GIVERS_PATH}/update-caregiver`;
export const ADD_CARE_GIVERS_PATH = `${MY_CARE_GIVERS_PATH}/add-caregiver`;
export const UPDATE_CARE_GIVERS_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/update-status-caregiver`;
export const ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH = `${MY_CARE_GIVERS_PATH}/received-approval-caregiver`;
export const ADD_CARE_GIVERS_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/add-status-caregiver`;
export const CARE_GIVERS_FILL_MY_INFO_PATH = `${MY_CARE_GIVERS_PATH}/fill-my-info`;
export const ACCEPT_CAREGIVERS_FILL_MY_INFO_PATH = `${MY_CARE_GIVERS_PATH}/accept/fill-my-info`;
export const CANCEL_CARE_GIVERS_PATH = `${MY_CARE_GIVERS_PATH}/cancel-caregiver`;

// CARE_RECIPIENTS
export const CARE_GIVERS_ADD_FAMILY_FRIEND_PATH = `${MY_CARE_GIVERS_PATH}/accept-adult-care-recipient`;
export const ADD_CARE_RECIPIENT_PATH = `${MY_CARE_GIVERS_PATH}/add-adult-care-recipient`;
export const UPDATE_CARE_RECIPIENT_PATH = `${MY_CARE_GIVERS_PATH}/update-adult-care-recipient`;
export const ADD_CARE_RECIPIENT_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/add-status-adult-care-recipient`;
export const UPDATE_CARE_RECIPIENT_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/update-status-adult-care-recipient`;
export const CARE_RECIPIENT_FILL_MY_INFO_PATH = `${MY_CARE_GIVERS_PATH}/fill-my-info-adult-care-recipient`;
export const CANCEL_CARE_RECIPIENT_PATH = `${MY_CARE_GIVERS_PATH}/cancel-adult-care-recipient`;
export const ADD_CHILDREN_HEALTH_PATH = `${MY_CARE_GIVERS_PATH}/add-child-care-recipient`;
export const UPDATE_CHILDREN_HEALTH_PATH = `${MY_CARE_GIVERS_PATH}/update-child-care-recipient`;
export const ADD_CHILDREN_HEALTH_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/add-status-child-care-recipient`;
export const UPDATE_CHILDREN_HEALTH_SUCCESS_PATH = `${MY_CARE_GIVERS_PATH}/update-status-child-care-recipient`;

// CHATBOT
export const CHATBOT_PATH = '/chatbot/app';
export const CHATBOT_PUBLIC_PATH = '/public/chatbot/app';

// CHILDREN HEALTH BIRTH INFORMATION
export const HEALTH_RECORDS_BIRTH_INFORMATION_PATH = '/childrens-health/birth-information';

// CHILDREN HEALTH MILESTONES
export const CHILDREN_HEALTH_MILESTONES_PATH = '/childrens-health/milestones';
export const CHILDREN_HEALTH_MILESTONES_TODO_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/todo`;
export const CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/habit-tracker/by-categories/:itemId`;
export const CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/habit-tracker/by-categories/:itemId/details/:id`;
export const CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_PHASE_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/habit-tracker/by-phase/:id`;
export const CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_AGE_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/habit-tracker/by-age/:itemId/details/:id`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-phase`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-phase/:id`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-age`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-age/:itemId`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-age/:itemId/archived`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-age/:itemId/archived/:id`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-age/:itemId/details/:id`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-categories`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-categories/:itemId`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-categories/:itemId/archived`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-categories/:itemId/archived/:id`;
export const CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_DETAILS_PATH = `${CHILDREN_HEALTH_MILESTONES_PATH}/by-categories/:itemId/details/:id`;

// SCHOOL DENTAL RECORDS
export const SCHOOL_DENTAL_RECORDS_PATH = '/school-health/dental-record';
export const SCHOOL_DENTAL_RECORD_DETAILS_PATH = `${SCHOOL_DENTAL_RECORDS_PATH}/details`;

// SCHOOL HEALTH ASSESSMENT
export const SCHOOL_HEALTH_ASSESSMENT_SUMMARY_PATH = '/school-health/assessment-summary';
export const SCHOOL_HEALTH_ASSESSMENT_SUMMARY_DETAILS_PATH = `${SCHOOL_HEALTH_ASSESSMENT_SUMMARY_PATH}/details`;

// CHILDREN HEALTH GROWTH CHARTS
export const GROWTH_CHARTS_PATH = '/childrens-health/growth-charts';
export const GROWTH_CHARTS_ENTRIES_PATH = `${GROWTH_CHARTS_PATH}/entries`;
export const ADD_GROWTH_ENTRY_PATH = `${GROWTH_CHARTS_PATH}/add-entry`;
export const EDIT_GROWTH_ENTRY_BASE_PATH = `${GROWTH_CHARTS_PATH}/edit-entry`;
export const EDIT_GROWTH_ENTRY_PATH = `${GROWTH_CHARTS_PATH}/edit-entry/:progressId`;

// NOTIFICATIONS
export const SCHOOL_HEALTH_NOTIFICATIONS_PATH = '/notification/school-health';
export const SCHOOL_HEALTH_NOTIFICATIONS_DETAILS_PATH = `${SCHOOL_HEALTH_NOTIFICATIONS_PATH}/details`;
export const CHILDREN_HEALTH_NOTIFICATIONS_PATH = '/notification/childrens-health';
export const CHILDREN_HEALTH_NOTIFICATIONS_DETAILS_PATH = `${CHILDREN_HEALTH_NOTIFICATIONS_PATH}/details`;
export const CHILDREN_HEALTH_NOTIFICATIONS_ARTICLES_PATH = `${CHILDREN_HEALTH_NOTIFICATIONS_PATH}/articles`;
export const CHILDREN_IMMUNISATION_NOTIFICATIONS_PATH = '/notification/childrens-immunisation';

// APPOINTMENT
export const APPOINTMENT_PATH = '/appointments';
export const APPOINTMENT_RESCHEDULE_PATH = `${APPOINTMENT_PATH}/reschedule`;
export const APPOINTMENT_RESCHEDULE_LINKED_PATH = `${APPOINTMENT_PATH}/reschedule-linked`;
export const APPOINTMENT_RESCHEDULE_CONFIRM_PATH = `${APPOINTMENT_PATH}/reschedule/confirm`;
export const APPOINTMENT_RESCHEDULE_SUCCESS_PATH = `${APPOINTMENT_PATH}/reschedule/success`;
export const APPOINTMENT_RESCHEDULE_FAILURE_PATH = `${APPOINTMENT_PATH}/reschedule/failure`;
export const APPOINTMENT_BOOK_NEXT_PATH = `${APPOINTMENT_PATH}/book-next`;
export const APPOINTMENT_BOOK_NEXT_AODTH_FORM_PATH = `${APPOINTMENT_PATH}/book-next/aodth/form`;
export const APPOINTMENT_BOOK_NEXT_AODTH_NOTICE_PATH = `${APPOINTMENT_PATH}/book-next/aodth/notice`;
export const APPOINTMENT_BOOK_NEXT_CONFIRM_PATH = `${APPOINTMENT_PATH}/book-next/confirm`;
export const APPOINTMENT_BOOK_NEXT_SUCCESS_PATH = `${APPOINTMENT_PATH}/book-next/success`;
export const APPOINTMENT_BOOK_NEXT_FORM_PATH = `${APPOINTMENT_PATH}/book-next/form`;
export const APPOINTMENT_BOOK_NEXT_FORM_SUCCESS_PATH = `${APPOINTMENT_PATH}/book-next/form/success`;
export const APPOINTMENT_MAKE_NEW_PATH = `${APPOINTMENT_PATH}/make-new`;
export const APPOINTMENT_MAKE_NEW_PREFERRED_POLYCLINIC_PATH = `${APPOINTMENT_PATH}/make-new/setup-preferred-polyclinic`;
export const APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic`;
export const APPOINTMENT_MAKE_NEW_CONFIRM_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/confirm`;
export const APPOINTMENT_MAKE_NEW_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/success`;
export const APPOINTMENT_MAKE_NEW_FAILURE_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/failure`;
export const APPOINTMENT_MAKE_NEW_AODTH_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/aodth`;
export const APPOINTMENT_MAKE_NEW_AODTH_AVAILABLE_SLOT_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/aodth/available-slot-selection`;
export const APPOINTMENT_MAKE_NEW_AODTH_CONFIRM_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/aodth/confirm`;
export const APPOINTMENT_MAKE_NEW_AODTH_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/aodth/success`;
export const APPOINTMENT_MAKE_NEW_SELECT_SERVICE_TYPE_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/select-service-type`;
export const APPOINTMENT_MAKE_NEW_SELECT_LOCATION_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/select-location`;
export const APPOINTMENT_MAKE_NEW_SELECT_AUTOGEN_LOCATION_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/autogen-location`;
export const APPOINTMENT_MAKE_NEW_SELECT_DOCTOR_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/select-doctor`;
export const APPOINTMENT_REQUEST_FORM_WITHOUT_TYPE_PATH = '/appointments/make-new/form/request-form';
export const APPOINTMENT_REQUEST_FORM_PATH = `${APPOINTMENT_REQUEST_FORM_WITHOUT_TYPE_PATH}/:formType`;
export const APPOINTMENT_REQUEST_FORM_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/form/request-form-success`;
export const APPOINTMENT_CERVICAL_CANCER_FORM_PATH = `${APPOINTMENT_PATH}/make-new/form/cervical-cancer`;
export const APPOINTMENT_CERVICAL_CANCER_FORM_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/form/cervical-cancer/success`;
export const APPOINTMENT_BREAST_CANCER_FORM_PATH = `${APPOINTMENT_PATH}/make-new/form/breast-cancer`;
export const APPOINTMENT_BREAST_CANCER_FORM_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/form/breast-cancer/success`;
export const APPOINTMENT_TRIAGE_QUESTIONNAIRE_PATH = `${APPOINTMENT_PATH}/make-new/triage-questionnaire`;
export const APPOINTMENT_DEDICATED_ATTENTION_PATH = `${APPOINTMENT_PATH}/make-new/triage-questionnaire/dedicated-attention`;
export const APPOINTMENT_BEFORE_CARE_PATH = `${APPOINTMENT_PATH}/make-new/before-care`;
export const APPOINTMENT_REGISTRATION_PATH = `${APPOINTMENT_PATH}/registration`;
export const APPOINTMENT_REGISTRATION_QUEUE_STATUS_AND_JOURNEY_PATH = `${APPOINTMENT_PATH}/registration/queue-status-journey/:encounter`;
export const APPOINTMENT_REGISTRATION_QUEUE_JOURNEY_PATH = `${APPOINTMENT_PATH}/registration/queue-journey/:encounter`;
export const APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_INTRODUCE_PATH = `${APPOINTMENT_PATH}/pre-consult-questionnaire/introduce`;
export const APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_QUESTION_SECTION_PATH = `${APPOINTMENT_PATH}/pre-consult-questionnaire/question-section`;
export const APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_REVIEW_PATH = `${APPOINTMENT_PATH}/pre-consult-questionnaire/review`;
export const APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_SUCCESS_PATH = `${APPOINTMENT_PATH}/pre-consult-questionnaire/success`;
export const APPOINTMENT_ACCOMPANYING_VISITORS_PATH = `${APPOINTMENT_PATH}/accompanying-visitors`;
export const APPOINTMENT_ACCOMPANYING_VISITOR_ADDING_PATH = `${APPOINTMENT_PATH}/accompanying-visitors/:addType`;
export const APPOINTMENT_NON_HAS_REQUEST_FORM_PATH = `${APPOINTMENT_PATH}/hsg/non-has-request-form`;
export const APPOINTMENT_NON_HAS_SCREENING_REQUEST_FORM_PATH = `${APPOINTMENT_PATH}/hsg/screening/non-has-request-form`;
export const APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH = `${APPOINTMENT_PATH}/make-new/has-request-form/patient`;
export const APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH = `${APPOINTMENT_PATH}/make-new/has-request-form/otp`;
export const APPOINTMENT_PRECHECKPAGE_PATH = `${APPOINTMENT_PATH}/make-new/pre-check-page`;

// APPOINTMENT FV
export const APPOINTMENT_MAKE_NEW_BOOK_INSTITUTE_SPECIALTY_PATH = `${APPOINTMENT_PATH}/make-new/book-institute`;
export const APPOINTMENT_FV_REFERRAL_SELECTION_PATH = `${APPOINTMENT_PATH}/make-new/fv/referral-selection`;
export const APPOINTMENT_FV_SELECT_DOCTOR_PATH = `${APPOINTMENT_PATH}/make-new/fv/select-doctor`;
export const APPOINTMENT_FV_SLOT_SELECTION_PATH = `${APPOINTMENT_PATH}/make-new/fv/slot-selection`;
export const APPOINTMENT_FV_CONFIRMATION_PATH = `${APPOINTMENT_PATH}/make-new/fv/confirmation`;
export const APPOINTMENT_FV_SUCCESS_PATH = `${APPOINTMENT_PATH}/make-new/fv/success`;
export const APPOINTMENT_FV_FAILURE_PATH = `${APPOINTMENT_PATH}/make-new/fv/failure`;

// APPOINTMENT PUBLIC
export const APPOINTMENT_PUBLIC_REQUEST_FORM_PATH = `/public/appointments/make-new/form/request-form`;

// AUTOGEN
export const APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_SELECTION_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/autogen-slot-selection`;
export const APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_CONFIRM_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/autogen-confirm`;

// DOCTOR CONSULT
export const APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_URTI_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/doctor-consult/urti-questionnaire`;
export const APPOINTMENT_MAKE_NEW_SELECT_LOCATION_DOCTOR_CONSULT_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/doctor-consult/select-location`;
export const APPOINTMENT_BEFORE_CARE_DOCTOR_CONSULT_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/doctor-consult/before-care`;
export const APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_SLOT_SELECTION_PATH = `${APPOINTMENT_PATH}/make-new/book-polyclinic/doctor-consult/slot-selection`;

// HSG
const HEALTHIERSG_PATH = '/healthiersg';
export const HEALTHIERSG_NO_ACCESS_PATH = `${HEALTHIERSG_PATH}/no-access`;
export const HEALTHIERSG_RESULTSANDRECORDS_PATH = `${HEALTHIERSG_PATH}/results-and-records`;
export const HEALTHIERSG_ABOUT_PATH = `${HEALTHIERSG_PATH}/about`;
export const HEALTHIERSG_RECOMMENDATION_SIGNPOSTING_PATH = `${HEALTHIERSG_PATH}/recommendation/signposting`;
export const HEALTHIERSG_RESULTSANDRECORDS_EDIT_PATH = `${HEALTHIERSG_PATH}/results-and-records/edit`;

export const HEALTHIERSG_ENROLLMENT_PATH = `${HEALTHIERSG_PATH}/enrolment`;
export const HEALTHIERSG_ENROLLMENT_CHANGE_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/change`;
export const HEALTHIERSG_ENROLLMENT_INTRO_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/intro`;
export const HEALTHIERSG_ENROLLMENT_INTROSPLASH_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/intro-splash`;
export const HEALTHIERSG_ENROLLMENT_INTROFIRSTSTEP_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/first-step`;
export const HEALTHIERSG_ENROLLMENT_TERMS_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/terms`;
export const HEALTHIERSG_ENROLLMENT_FILTER_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/filter`;
export const HEALTHIERSG_ENROLLMENT_CONFIRM_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/confirm`;
export const HEALTHIERSG_ENROLLMENT_COMPLETE_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/complete`;
export const HEALTHIERSG_ENROLLMENT_CARERECIPIENT_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/care-recipient`;
export const HEALTHIERSG_ENROLLMENT_MORE_OPTIONS_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/more-options`;
export const HEALTHIERSG_ENROLLMENT_EXISTING_APPOINTMENT_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/existing-appointment`;
export const HEALTHIERSG_ENROLLMENT_APPOINTMENTS_PATH = `${HEALTHIERSG_ENROLLMENT_PATH}/appointments`;

export const HEALTHIERSG_QUESTIONNAIRE_PATH = `${HEALTHIERSG_PATH}/questionnaire`;
export const HEALTHIERSG_QUESTIONNAIRE_COMPLETED_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/completed`;
export const HEALTHIERSG_QUESTIONNAIRE_SCF_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/scf`;
export const HEALTHIERSG_QUESTIONNAIRE_SMOKING_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/smoking`;
export const HEALTHIERSG_QUESTIONNAIRE_SMOKING_DETAILS_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/smoking/details`;
export const HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/onboarding`;
export const HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_ANS_PATH = `${HEALTHIERSG_QUESTIONNAIRE_PATH}/onboarding-answers`;

export const HEALTHIERSG_HEALTHPLAN_PATH = `${HEALTHIERSG_PATH}/health-plan`;
export const HEALTHIERSG_ISENROLLED_ERROR_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/unauthorized`;
export const HEALTHIERSG_HEALTHPLAN_SIGNPOSTING_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/signposting`;
export const HEALTHIERSG_HEALTHPLAN_ERROR_PAGE_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/error-page`;
export const HEALTHIERSG_RESOURCES_LIVE_HEALTHY_ARTICLES_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/live-healthy/recommended-articles`;
export const HEALTHIERSG_HEALTHPLAN_VIEW_DISMISSED_ACTIONS_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/dismissed-actions`;
export const HEALTHIERSG_HEALTHPLAN_GET_VACCINATED_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/get-vaccinated`;

export const HEALTHIERSG_RECOMMENDED_PROGRAMMES_AND_ACTIVITIES_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/recommended-programmes-and-activities`;
export const HEALTHIERSG_HEALTHPLAN_SUMMARY_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/summary`;
export const HEALTHIERSG_WHATS_NEW_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/whats-new`;
export const HEALTHIERSG_PREVIOUS_HEALTHPLAN_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/summary/previous-health-plan`;
export const HEALTHIERSG_PREVIOUS_HEALTHPLAN_DETAIL_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/summary/previous-health-plan-detail`;
export const HEALTHIERSG_HEALTHPLAN_VACCINATION_DETAIL_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/vaccination-detail`;
export const HEALTHIERSG_LIFESTYLE_ACTIONS_RECOMMENDED_ARTICLES_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/lifestyle-actions/recommended-articles`;
export const HEALTHIERSG_LIFESTYLE_ACTION_LEARN_HOW_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/lifestyle-actions/learn-how`;
export const HEALTHIERSG_SMOKING_CESSATION_HISTORY_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/smoking-cessation/history`;
export const HEALTHIERSG_SMOKING_CESSATION_QUIT_GOAL_SUPPORT_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/smoking-cessation/quit-goal-support`;
export const HEALTHIERSG_SMOKING_CESSATION_GOAL_SUPPORT_ARTICLES_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/smoking-cessation/goal-support/recommended-articles`;

export const HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN = `${HEALTHIERSG_HEALTHPLAN_PATH}/exercise-plan`;
export const HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN_FEEDBACK = `${HEALTHIERSG_HEALTHPLAN_PATH}/exercise-plan/feedback`;
export const HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS = `${HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN}/exercise-details`;
export const HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS = `${HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN}/activity-details`;
export const HEALTHIERSG_LIFESTYLEACTIONS_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/lifestyle-actions`;
export const LIFESTYLEACTIONS_HEALTHPLAN_EXERCISE_PLAN = `${HEALTHIERSG_LIFESTYLEACTIONS_PATH}/exercise-plan`;
export const HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS_LIFESTYLEACTIONS = `${LIFESTYLEACTIONS_HEALTHPLAN_EXERCISE_PLAN}/exercise-details`;
export const HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS_LIFESTYLEACTIONS = `${LIFESTYLEACTIONS_HEALTHPLAN_EXERCISE_PLAN}/activity-details`;

const HEALTHIERSG_RECORDS_PATH = `${HEALTHIERSG_PATH}/records`;
export const HEALTHIERSG_RECORDS_HEALTH_SCREENING_PATH = `${HEALTHIERSG_RECORDS_PATH}/health-screening`;
export const HEALTHIERSG_YOUR_IMMUNISATION_RECORDS_PATH = `${HEALTHIERSG_RECORDS_PATH}/your-immunisation-records`;
export const HEALTHIERSG_RECORDS_COMPLETED_IMMUNISATION_PATH = `${HEALTHIERSG_RECORDS_PATH}/completed-immunisation`;
export const HEALTHIERSG_RECORDS_NATIONALLY_RECOMMENDED_IMMUNISATION_PATH = `${HEALTHIERSG_RECORDS_PATH}/nationally-recommended`;
export const HEALTHIERSG_RECORDS_MORE_ABOUT_IMMUNISATION_PATH = `${HEALTHIERSG_RECORDS_PATH}/more-about`;
export const HEALTHIERSG_RECORDS_UPCOMING_IMMUNISATION_PATH = `${HEALTHIERSG_RECORDS_PATH}/nationally-recommended/upcoming-immunisation`;
export const HEALTHIERSG_RECORDS_MISSED_IMMUNISATION_PATH = `${HEALTHIERSG_RECORDS_PATH}/nationally-recommended/missed-immunisation`;
export const HEALTHIERSG_RECORDS_MANAGE_CONDITION_PATH = `${HEALTHIERSG_RECORDS_PATH}/manage-condition`;
export const HEALTHIERSG_RECORDS_SCREENING_RESULTS_PATH = `${HEALTHIERSG_RECORDS_PATH}/screening-results`;
export const HEALTHIERSG_RECORDS_SCREENING_UNDERSTAND_READINGS_PATH = `${HEALTHIERSG_RECORDS_PATH}/understand-readings/:screeningType`;
export const HEALTHIERSG_SCREENING_RECORDS_DETAILED_RESULTS_PATH = `${HEALTHIERSG_RECORDS_PATH}/screening-results/:screeningType`;
export const HEALTHIERSG_RECORDS_SCREENING_DETAILED_RESULTS_PATH = `${HEALTHIERSG_RECORDS_PATH}/screening-results/:screeningType`;
export const HEALTHIERSG_RECORDS_SCREENING_RESULTS_INDICATOR_PATH = `${HEALTHIERSG_RECORDS_PATH}/screening-results-indicator/:recordType`;

export const HEALTHIERSG_RECORDS_SCREENING_PATH = `${HEALTHIERSG_RECORDS_PATH}/screening`;
export const HEALTHIERSG_RECORDS_SCREENING_LISTING_PATH = `${HEALTHIERSG_RECORDS_SCREENING_PATH}/listing`;
export const HEALTHIERSG_RECORDS_SCREENING_HISTORY_PATH = `${HEALTHIERSG_RECORDS_SCREENING_PATH}/history/:screeningType`;
export const HEALTHIERSG_RECORDS_SCREENING_DETAILS_PATH = `${HEALTHIERSG_RECORDS_SCREENING_PATH}/details/:screeningType`;
export const HEALTHIERSG_RECORDS_SCREENING_LATEST_DETAILS_PATH = `${HEALTHIERSG_RECORDS_SCREENING_PATH}/latest-details/:screeningType`;

const HEALTHIERSG_SCREENING_JOURNEY_PATH = '/healthiersg/screening-journey';
export const HEALTHIERSG_SCREENING_JOURNEY_TO_BOOK_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/ready-to-book`;
export const HEALTHIERSG_SCREENING_JOURNEY_GO_FOR_SCREENING_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/go-for-screening`;
export const HEALTHIERSG_SCREENING_JOURNEY_APPOINTMENT_MADE_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/appointment-made`;
export const HEALTHIERSG_SCREENING_JOURNEY_NOT_AVAILABLE_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/not-available`;
export const HEALTHIERSG_SCREENING_JOURNEY_AVAILABLE_ON_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/available-on`;
export const HEALTHIERSG_SCREENING_RESULTS_PENDING_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/pending-results`;
export const HEALTHIERSG_SCREENING_UNDERSTAND_READINGS_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/understand-readings/:screeningType`;
export const HEALTHIERSG_SCREENING_RESULTS_PATH = `${HEALTHIERSG_SCREENING_JOURNEY_PATH}/screening-results`;
export const HEALTHIERSG_SCREENING_DETAILED_RESULTS_PATH = `${HEALTHIERSG_PATH}/screening-results/:screeningType`;
export const HEALTHIERSG_SCREENING_RESULTS_INDICATOR_PATH = `${HEALTHIERSG_PATH}/screening-results-indicator/:recordType`;
export const HEALTHIERSG_SCREENING_QUESTION_PATH = `${HEALTHIERSG_PATH}/screening-question/:type/:service`;
export const HEALTHIERSG_VACCINATION_ARTICLES_PATH = `${HEALTHIERSG_HEALTHPLAN_PATH}/vaccination/recommended-articles`;

// HSG Health Plan Entrypoint to Breast Cancer Request Form (linked to Appointments shared content)
const HEALTHIERSG_APPOINTMENTS_PATH = `${HEALTHIERSG_PATH}${APPOINTMENT_PATH}`;
export const HEALTHIERSG_APPOINTMENTS_BEFORE_CARE_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/before-care`;
export const HEALTHIERSG_APPOINTMENTS_LOCATION_SELECTION_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/location-selection`;
export const HEALTHIERSG_APPOINTMENTS_FORM_NAVIGATION_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/form-navigation/:screeningType`;
export const HEALTHIERSG_APPOINTMENTS_FORM_SUCCESS_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/form/:screeningType/success`;
export const HEALTHIERSG_APPOINTMENTS_BREAST_CANCER_REQUEST_FORM_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/form/breast-cancer`;
export const HEALTHIERSG_APPOINTMENTS_COLORECTAL_CANCER_REQUEST_FORM_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/form/colorectal-cancer`;
export const HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/has-request-form/patient`;
export const HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/has-request-form/otp`;

// HSG SCREENING
export const APPOINTMENT_MAKE_NEW_HSG_SCREENING_SLOT_SELECTION_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/hsg-screening/slot_selection`;
export const APPOINTMENT_MAKE_NEW_HSG_SCREENING_CONFIRM_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/hsg-screening-confirm`;
export const APPOINTMENT_MAKE_NEW_HSG_SCREENING_SUCCESS_PATH = `${HEALTHIERSG_APPOINTMENTS_PATH}/make-new/hsg-screening-success`;

export const MY_HEALTH_PROFILE_BASE_PATH = `/personal-health`;

export const STANDARD_HEALTH_PROFILES_PATH = '/health-profiles';

// FAMILY AND FRIENDS HEALTH PROFILE
export const MY_FAMILY_AND_FRIEND_HEALTH_DETAILS_PATH = '/family-friends-health/details';

// CHILDREN HEALTH PROFILE
export const MY_CHILDREN_PROFILE_DETAILS_PATH = '/childrens-health/details';

// PERSONAL HEALTH
export const MY_PROFILE_PATH = '/my-profile';
export const MY_PROFILE_VERIFICATION_PATH = `${MY_PROFILE_PATH}/verify`;
export const MY_PROFILE_MISMATCH_PATH = `${MY_PROFILE_PATH}/mismatch`;

// MEDREFILL
export const MEDREFILL_PATH = '/medication-refill';
const MEDREFILL_REFILL_PATH = '/refill';
const MEDREFILL_TOPUP_PATH = '/topup';
export const MEDREFILL_ORDER_TYPE_PATH = `${MEDREFILL_PATH}/order-type`;
export const MEDREFILL_POLYCLINICS_PATH = `${MEDREFILL_PATH}/polyclinics`;
export const MEDREFILL_SUMMARY_PATH = `${MEDREFILL_PATH}/summary`;
export const MEDREFILL_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}/successful-request`;
export const MEDREFILL_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}/unsuccessful-request`;
export const MEDREFILL_ORDER_FOR_OTHERS_PATH = `${MEDREFILL_PATH}/order-for-others`;
export const MEDREFILL_INSTITUTION_CODE_PATH = `${MEDREFILL_PATH}/institutions-list/:institutionCode`;

// MEDREFILL REFILL
export const MEDREFILL_REFILL_ORIGINAL_DETAILS_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/original-details`;
export const MEDREFILL_REFILL_PRESCRIPTION_LIST_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/prescriptions`;
export const MEDREFILL_REFILL_REFILL_OPTIONS_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/refill-options`;
export const MEDREFILL_REFILL_ADD_PARTICULARS_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/add-particulars`;
export const MEDREFILL_REFILL_COLLECTIONS_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/collections`;
export const MEDREFILL_REFILL_TNC_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/terms-and-conditions`;
export const MEDREFILL_REFILL_PAYMENT_MODE_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/select-payment-mode`;
export const MEDREFILL_REFILL_SUMMARY_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/summary`;
export const MEDREFILL_REFILL_PRESCRIBED_LIST_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/prescribed-list`;
export const MEDREFILL_REFILL_PRESCRIBED_MEDICATION_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/prescribed-medications`;
export const MEDREFILL_REFILL_SORT_FILTER_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/sort-filter`;
export const MEDREFILL_REFILL_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/successful-request`;
export const MEDREFILL_REFILL_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}${MEDREFILL_REFILL_PATH}/unsuccessful-request`;

// MEDREFILL TOPUP
export const MEDREFILL_TOPUP_COLLECTIONS_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/collections`;
export const MEDREFILL_TOPUP_TNC_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/terms-and-conditions`;
export const MEDREFILL_TOPUP_SUMMARY_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/summary`;
export const MEDREFILL_TOPUP_CLINICS_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/clinics`;
export const MEDREFILL_TOPUP_REPEAT_PRESCRIPTION_LIST_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/repeat-prescriptions`;
export const MEDREFILL_TOPUP_ADD_PARTICULARS_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/add-particulars`;
export const MEDREFILL_TOPUP_PAYMENT_MODE_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/select-payment-mode`;
export const MEDREFILL_TOPUP_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/successful-request`;
export const MEDREFILL_TOPUP_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PATH}${MEDREFILL_TOPUP_PATH}/unsuccessful-request`;

// MEDREFILL PUBLIC
export const MEDREFILL_PUBLIC_PATH = '/public/medication-refill';
export const MEDREFILL_PUBLIC_INSTITUTION_PATH = `${MEDREFILL_PUBLIC_PATH}/institutions`;
export const MEDREFILL_PUBLIC_TOPUP_CLINICS_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/clinics`;
export const MEDREFILL_PUBLIC_POLYCLINICS_PATH = `${MEDREFILL_PUBLIC_PATH}/polyclinics`;
export const MEDREFILL_PUBLIC_ORDER_TYPE_PATH = `${MEDREFILL_PUBLIC_PATH}/order-type`;
export const MEDREFILL_PUBLIC_REFILL_ORIGINAL_DETAILS_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/original-details`;
export const MEDREFILL_PUBLIC_REFILL_PRESCRIPTION_LIST_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/prescriptions`;
export const MEDREFILL_PUBLIC_TOPUP_REPEAT_PRESCRIPTION_LIST_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/repeat-prescriptions`;
export const MEDREFILL_PUBLIC_REFILL_REFILL_OPTIONS_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/refill-options`;
export const MEDREFILL_PUBLIC_TOPUP_ADD_PARTICULARS_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/add-particulars`;
export const MEDREFILL_PUBLIC_REFILL_ADD_PARTICULARS_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/add-particulars`;
export const MEDREFILL_PUBLIC_TOPUP_SUMMARY_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/summary`;
export const MEDREFILL_PUBLIC_REFILL_SUMMARY_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/summary`;
export const MEDREFILL_PUBLIC_TOPUP_COLLECTIONS_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/collections`;
export const MEDREFILL_PUBLIC_REFILL_COLLECTIONS_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/collections`;
export const MEDREFILL_PUBLIC_TOPUP_TNC_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/terms-and-conditions`;
export const MEDREFILL_PUBLIC_REFILL_TNC_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/terms-and-conditions`;
export const MEDREFILL_PUBLIC_TOPUP_PAYMENT_MODE_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/select-payment-mode`;
export const MEDREFILL_PUBLIC_REFILL_PAYMENT_MODE_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/select-payment-mode`;
export const MEDREFILL_PUBLIC_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PUBLIC_PATH}/successful-request`;
export const MEDREFILL_PUBLIC_TOPUP_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/successful-request`;
export const MEDREFILL_PUBLIC_REFILL_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/successful-request`;
export const MEDREFILL_PUBLIC_TOPUP_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PUBLIC_PATH}/topup/unsuccessful-request`;
export const MEDREFILL_PUBLIC_REFILL_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_PUBLIC_PATH}/refill/unsuccessful-request`;

// MEDREFILL HISTORY
export const MEDREFILL_HISTORY_PATH = '/medication-refill/history';
export const MEDREFILL_HISTORY_DETAILS_PATH = `${MEDREFILL_HISTORY_PATH}/details`;
export const MEDREFILL_HISTORY_ORDERCANCEL_SUCCESSFUL_REQUEST_PATH = `${MEDREFILL_HISTORY_PATH}/successful-request`;
export const MEDREFILL_HISTORY_ORDERCANCEL_UNSUCCESSFUL_REQUEST_PATH = `${MEDREFILL_HISTORY_PATH}/unsuccessful-request`;

// FINANCIAL_CONSENTS
export const FINANCIAL_CONSENTS_PATH = '/financial-consents';
export const FINANCIAL_CONSENTS_MCAF_PATH = `${FINANCIAL_CONSENTS_PATH}/medical-claims-authorisation-form`;
export const FINANCIAL_CONSENTS_MCAF_EDIT_PATH = `${FINANCIAL_CONSENTS_PATH}/update-medical-claims-authorisation-form`;
export const FINANCIAL_CONSENTS_MCAF_SUCCESS_PATH = `${FINANCIAL_CONSENTS_PATH}/medical-claims-authorisation-form/status`;
export const FINANCIAL_CONSENTS_DATA_SHARING_PATH = `${FINANCIAL_CONSENTS_PATH}/data-sharing`;
export const FINANCIAL_CONSENTS_DATA_SHARING_SUCCESS_PATH = `${FINANCIAL_CONSENTS_PATH}/data-sharing/status`;
export const FINANCIAL_CONSENTS_TERM_AND_CONDITIONS_PATH = `${FINANCIAL_CONSENTS_PATH}/term-and-conditions`;
export const FINANCIAL_CONSENTS_DEFINITIONS_PATH = `${FINANCIAL_CONSENTS_PATH}/definitions`;

// HEALTH RISK ASSESSMENT
export const HEALTH_RISK_ASSESSMENT_PATH = '/health-risk-assessment';
export const HEALTH_RISK_ASSESSMENT_DETAILS_PATH = `${HEALTH_RISK_ASSESSMENT_PATH}/details`;

// MRRP
export const MRRP_MEDICAL_REPORTS_PATH = '/medical-reports-certificates-requests';
export const MRRP_MEDICAL_REPORTS_VIEW_SELECT_INSTITUTION_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/view-request/select-institution`;
export const MRRP_MEDICAL_REPORTS_LISTING_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/view-request/summary`;
export const MRRP_MEDICAL_REPORTS_DETAILS_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/view-request/summary/:id`;
export const MRRP_MEDICAL_REPORTS_NEW_SELECT_INSTITUTION_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/select-institution`;
export const MRRP_MEDICAL_REPORTS_TNC_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/select-institution/terms-and-condition`;
export const MRRP_MEDICAL_REPORTS_TNC_DETAILS_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/select-institution/terms-and-condition/details`;
export const MRRP_MEDICAL_REPORTS_PATIENT_NOT_FOUND_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/select-institution/not-found`;
export const MRRP_MEDICAL_REPORTS_REPORTS_DETAILS_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/report-details`;
export const MRRP_MEDICAL_REPORTS_PARTICULARS_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/particulars`;
export const MRRP_MEDICAL_REPORTS_COLLECTION_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/collection`;
export const MRRP_MEDICAL_REPORTS_REQUEST_SUMMARY_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/summary`;
export const MRRP_MEDICAL_REPORTS_REQUEST_PAYMENT_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/payment`;
export const MRRP_MEDICAL_REPORTS_REQUEST_PAYMENT_STATUS_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/payment/status`;
export const MRRP_MEDICAL_REPORTS_REQUEST_PAYMENT_DD_RECEIPT_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/payment/direct-debit-receipt`;
export const MRRP_MEDICAL_REPORTS_REQUEST_PAYMENT_COMPLETED_PATH = `${MRRP_MEDICAL_REPORTS_PATH}/new-request/payment/completed`;

// HISTO/CYTO REPORT
export const HISTO_CYTO_RPORTS_PATH = `${LAB_TEST_REPORTS_PATH}/histo-cyto-reports`;
export const HISTO_CYTO_RPORTS_DETAILS_PATH = `${HISTO_CYTO_RPORTS_PATH}/details`;

// Genetics
export const GENETIC_REPORTS_PATH = `${LAB_TEST_REPORTS_PATH}/genetic`;
export const GENETIC_DETAILS_PATH = `${LAB_TEST_REPORTS_PATH}/genetic/details`;

// DEROM
export const DEROM_PATH = '/derom';
export const DEROM_DASHBOARD_PATH = '/derom/dashboard';
export const DEROM_TEST_RESULTS_PATH = '/derom/test-results';
export const DEROM_VACCINATION_RECORDS_PATH = `/derom/vaccination-records`;

// IMPORTANT NOTICES/NOTIFICATIONS
export const INBOX_PUBLIC_NOTIFICATIONS_PATH = '/public/inbox/notifications';
export const INBOX_NOTIFICATIONS_PATH = '/inbox/notifications';
export const INBOX_NOTIFICATION_DETAILS_PATH = '/inbox/notifications/details';

// ACTIVITIES & EVENTS
export const ACTIVITIES_AND_EVENTS_PATH = '/activities-and-events';
export const ACTIVITIES_AND_EVENTS_FILTER_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/filter`;
export const ACTIVITIES_AND_EVENTS_FILTER_ACTIVITIES_TYPE_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/filter/activities-type`;
export const ACTIVITIES_AND_EVENTS_DETAILS_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/details/:eventId/:organization`;
export const ACTIVITIES_AND_EVENTS_OTHER_SESSIONS_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/other-sessions/:eventId/:organization`;
export const ACTIVITIES_AND_EVENTS_BOOKING_CONFIRMATION_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/booking-confirmation/:eventId/:organization`;
export const ACTIVITIES_AND_EVENTS_BOOKING_STATUS_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/booking-status/:eventId/:organization`;
export const ACTIVITIES_AND_EVENTS_BOOKED_DETAILS_PATH = `${ACTIVITIES_AND_EVENTS_PATH}/booked-activities/details/:eventId/:organization`;
export const ACTIVITIES_AND_EVENTS_BOOKED_ACTIVITIES = `${ACTIVITIES_AND_EVENTS_PATH}/booked-activities`;

export const SITE_CORE_URL = {
  aboutUs: '/about-healthhub',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-and-conditions',
  contactUs: '/contact-us',
  healthConditions: '/health-conditions',
  healthConditionsAcne: '/health-conditions/acne',
  healthConditionsCoughAndCold: '/health-conditions/cough',
  healthConditionsColdSores: '/health-conditions/cold-sores',
  healthConditionsDiarrhoea: '/health-conditions/diarrhoea',
  healthConditionsConstipation: '/health-conditions/constipation',
  healthConditionsHeadache: '/health-conditions/headache',
  healthConditionsColorectalCancer: '/health-conditions/colorectalcancer',
  healthConditionsCardiovascularDisease: '/health-conditions/cardiovascular-disease',
  highlightsAndInsightsExpertVoices: '/highlights-and-insights/expert-voices',
  highlightsAndInsightsHealthSafety: '/highlights-and-insights/health-safety-advisory',
  medicationsDevices: '/medication-devices-and-treatment/medications?filter=alphabets#articlealphabets_alphabets=A',
  medicationsDevicesAntifungal: '/medication-devices-and-treatment/medications/antifungal-topical',
  medicationsDevicesBenzhexol: '/medication-devices-and-treatment/medications/benzhexol',
  medicationsDevicesEmpagliflozin: '/medication-devices-and-treatment/medications/empagliflozin',
  medicationsDevicesOmeprazole: '/medication-devices-and-treatment/medications/omeprazole',
  medicationsDevicesBenztropine: '/medication-devices-and-treatment/medications/benztropine',
  medicationsDevicesDomperidone: '/medication-devices-and-treatment/medications/domperidone',
  medicationsDevicesInfluenzaVaccine: '/medication-devices-and-treatment/medications/influenza-vaccine',
  medicationsDevicesPyridostigmine: '/medication-devices-and-treatment/medications/pyridostigmine',
  supportCareProgrammes: '/support-and-tools/support-and-care-programmes',
  supportCostAndFinancing: '/support-and-tools/costs-and-financing',
  supportScreening: '/support-and-tools/screening',
  supportStatisticsHealthcare: '/support-and-tools/statistics-on-healthcare',
  supportToolsAndResources: '/support-and-tools/tools-and-resources',
  wellBeingActiveAgeing: '/well-being-and-lifestyle/active-ageing',
  wellBeingCaregiving: '/well-being-and-lifestyle/caregiving',
  wellBeingChildAndTeensHealth: '/well-being-and-lifestyle/child-and-teens-health',
  wellBeingExerciseAndFitness: '/well-being-and-lifestyle/exercise-and-fitness',
  wellBeingFoodDietAndNutrition: '/well-being-and-lifestyle/food-diet-and-nutrition',
  wellBeingHealthProgrammes: '/programmes',
  wellBeingMentalWellness: '/well-being-and-lifestyle/mental-wellness',
  wellBeingPersonalCare: '/well-being-and-lifestyle/personal-care',
  wellBeingPregnancyAndInfantHealth: '/well-being-and-lifestyle/pregnancy-and-infant-health',
  wellBeingSexualHealth: '/well-being-and-lifestyle/sexual-health',
  wellBeingSubstanceAddiction: '/well-being-and-lifestyle/substance-addiction',
  wellBeingTravelHealth: '/well-being-and-lifestyle/travel-health',
};

export const GOOGLE_URL = {
  privacyPolicy: 'https://policies.google.com/privacy',
  termsOfService: 'https://policies.google.com/terms',
};

export const SCAM_SHIELD_LINK = 'https://www.scamshield.gov.sg';

// ADMISSION
export const ADMISSIONS_PATH = '/admissions';
export const ADMISSIONS_ACKNOWLEDGEMENT_PATH = `${ADMISSIONS_PATH}/acknowledgement`;
export const ADMISSIONS_DETAILS_PATH = `${ADMISSIONS_PATH}/details`;
export const ADMISSIONS_DETAILS_SUBSIDIES_PATH = `${ADMISSIONS_PATH}/details/subsidies`;
export const ADMISSIONS_PAYMENT_HISTORY_PATH = `${ADMISSIONS_PATH}/payment-history`;
export const ADMISSIONS_PAYMENT_PATH = `${ADMISSIONS_PATH}/payment`;
export const ADMISSIONS_PAYMENT_STATUS_PATH = `${ADMISSIONS_PATH}/payment-status`;
export const ADMISSIONS_PAYMENT_WAITING_STATUS_PATH = `${ADMISSIONS_PATH}/payment-waiting-status`;
export const ADMISSIONS_PAYMENT_CALLBACK_PATH = `${ADMISSIONS_PATH}/payment/callback/:id?`;
export const ADMISSIONS_DETAILS_FILTER_PATH = `${ADMISSIONS_PATH}/details/filters`;

// EMERGENCY VISIT
export const EMERGENCY_VISIT_PATH = '/emergency-visit';
export const EMERGENCY_VISIT_SUMMARY_PATH = `${EMERGENCY_VISIT_PATH}/summary`;
export const EMERGENCY_VISIT_WAIT_TIME_PATH = `${EMERGENCY_VISIT_PATH}/wait-time`;
export const AGE_SELECTION_PATH = `${EMERGENCY_VISIT_PATH}/age-selection`;
export const ADULT_HDF_PATH = `${EMERGENCY_VISIT_PATH}/adult-hdf`;
export const CHILD_HDF_PATH = `${EMERGENCY_VISIT_PATH}/child-hdf`;
export const NHG_HDF_PATH = `${EMERGENCY_VISIT_PATH}/nhg-hdf`;
export const HDF_CONFIRMATION_PATH = `${EMERGENCY_VISIT_PATH}/hdf-confirmation`;
export const ADULT_HDF_EDIT_PATH = `${EMERGENCY_VISIT_PATH}/adult-hdf-edit`;
export const CHILD_HDF_EDIT_PATH = `${EMERGENCY_VISIT_PATH}/child-hdf-edit`;
export const NHG_HDF_EDIT_PATH = `${EMERGENCY_VISIT_PATH}/nhg-hdf-edit`;
export const HDF_CONFIRMATION_EDIT_PATH = `${EMERGENCY_VISIT_PATH}/hdf-confirmation-edit`;

export const ADULT_HDF_BEFORE_SUBMIT_PATH = `${EMERGENCY_VISIT_PATH}/adult-hdf-before-submit`;
export const CHILD_HDF_BEFORE_SUBMIT_PATH = `${EMERGENCY_VISIT_PATH}/child-hdf-before-submit`;
export const NHG_HDF_BEFORE_SUBMIT_PATH = `${EMERGENCY_VISIT_PATH}/nhg-hdf-before-submit`;

// PHARMACY QUEUE
export const PHARMACY_QUEUE_PATH = '/pharmacy-queue';
export const PHARMACY_QUEUE_SELECT_PHARMACY_PATH = `${PHARMACY_QUEUE_PATH}/select-pharmacy`;
export const PHARMACY_QUEUE_KIOSK_QUESTIONNAIRE_PATH = `${PHARMACY_QUEUE_PATH}/kiosk-questionnaire`;
export const PHARMACY_QUEUE_QUEUE_JOURNEY_PATH = `${PHARMACY_QUEUE_PATH}/queue-journey/:encounter`;
